// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote-module__quote___ciZO9","slide-alignment":"Quote-module__slide-alignment___2oFoj"};